const Messages = () => import('./_views/messages');

export default [
  {
    path: '/additional/messages',
    name: 'messages',
    component: Messages,
    meta: {
      title: 'Messages',
      group: 'additional',
      navigation: {
        position: 1,
        name: 'Messages',
        specialQueries: ['suffix'],
        to: {
          name: 'messages',
          query: {
            suffix: '',
            pageNum: '1',
          },
        },
      },
    },
  },
];
